import { SDK } from "@sdk";
import { combineEpics, ofType, Epic } from "redux-observable";
import { mergeMap, switchMap } from "rxjs/operators";
import {
  setUserPresence,
  setUserPresences,
} from "../../modules/user-presence/user-presence.actions";
import { iUser } from "@sdk/user-management/user-management.models";

const userPresenceLoadedEpic1: Epic = (action$) => {
  return action$.pipe(
    ofType("users/addNewUser"),
    // subscribe to actions observable
    switchMap(({ payload: { id: userId } }: { payload: { id: string } }) =>
      SDK.getRoomStatus(userId)
        .then((statusMap) => [
          setUserPresence({
            userId,
            isOnline: statusMap?.online || false,
          }),
        ])
        .catch(() => [])
    ),
    mergeMap((actions: any) => actions)
  );
};

const userPresenceLoadedEpic2: Epic = (action$) => {
  return action$.pipe(
    ofType("users/setAllUsers"),
    // subscribe to actions observable
    switchMap(({ payload: users }: { payload: iUser[] }) =>
      SDK.queryStatus(users.map((user: any) => user.id))
        .then((statusMap: any) => [
          setUserPresences(
            users
              .map((user) => user.id)
              .map((userId) => ({
                userId,
                isOnline: statusMap[userId] || false,
              }))
          ),
        ])
        .catch(() => [])
    ),
    // tap(() => console.log("Set All Users Fired")),
    mergeMap((actions: any) => actions)
  );
};

export const userPresenceLoader = combineEpics(
  userPresenceLoadedEpic1,
  userPresenceLoadedEpic2
);
